/* 馬超（字孟起） */
import { defineHero, U, D } from '../define.ts';

export default defineHero({
  id: 'machao', name: '馬超', sub: '字孟起', faction: 'shu', role: '刺客', weapon: 'spear',
  look: { weaponName: '虎頭湛金槍', eye: 'fierce', horns: true, fx: '#ffe28a', c: { armor: '#e6e9ee', sleeve: '#3e7b50', cape: '#f0f2f5', plume: '#f0f2f5', metal: '#e0b64e', trim: '#e0b64e', pole: '#e0b64e', boot: '#cfd5dc' } },
  skills: [
    ['衝鋒', 'charge', '向前衝刺一大段距離，路徑上的敵人受到 {75/150/225/300} 傷害。', { x: { dmg: [75, 150, 225, 300], speed: 800 }, aim: D(440, 40), cd: 14, mp: [110, 120, 130, 140] }],
    ['行動破壞', 'multi', '砍傷目標腳部，造成 {75/115/155/195} 傷害，並大幅降低攻速與移速 {3/4/5/6} 秒。', { x: { k: 'nuke', dmg: [75, 115, 155, 195], debuff: { as: 50, ms: 50, dur: [3, 4, 5, 6] }, fx: 'slam' }, aim: U(130), cd: 18, mp: 90 }],
    ['騎術', 'passive', '移動速度 +{5/9/13/18}%。', { pv: { msP: [5, 9, 13, 18] } }],
    ['萬馬奔騰', 'command', '呼叫西涼鐵騎接連衝過前方，每名騎兵造成 {60/100/140} 傷害，可傷害建築。', { x: { k: 'line', n: 24, gap: 0.25, dmg: [60, 100, 140], width: 240, rad: 34, speed: 720, shape: 'cavalry', persist: true, fromCast: true }, aim: D(640, 120), cd: 170, mp: [150, 200, 250], el: 'earth' }],
  ],
});
